import { useState } from "react";
import { useNavigate } from "react-router";
import { restoreAdminAccessToken } from "@/lib/api";
import { toastApiError } from "@/lib/errorMessages";
import { authService } from "@/services/authService";
import { useAuthStore } from "@/store/authStore";

export function useImpersonation() {
  const navigate = useNavigate();
  const impersonate = useAuthStore((state) => state.impersonate);
  const logout = useAuthStore((state) => state.logout);
  const [isStarting, setIsStarting] = useState(false);
  const [isStopping, setIsStopping] = useState(false);

  const startImpersonation = async (userId: string) => {
    setIsStarting(true);
    try {
      const { access_token } = await authService.impersonate(userId);
      impersonate(access_token);
      navigate("/");
    } catch (error) {
      toastApiError(error, "impersonateUser");
    } finally {
      setIsStarting(false);
    }
  };

  const stopImpersonation = async () => {
    setIsStopping(true);
    try {
      await restoreAdminAccessToken();
      navigate("/admin/users");
    } catch {
      logout();
      navigate("/login");
    } finally {
      setIsStopping(false);
    }
  };

  return {
    startImpersonation,
    stopImpersonation,
    isStarting,
    isStopping,
  };
}
